import {RecipeVariant, cva} from "@styled-system/css"

/**
 * Bodewell (and theme) text-link styles.
 *
 * - inline: in paragraphs — always underlined; #245B83 → hover #728A9C (THEME.css)
 * - standalone: bold, no underline (often with icons)
 * - footer: regular weight, underline on hover only
 */
export const linkStyles = cva({
  base: {
    color: "text.link",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    _hover: {
      color: "text.link.hover",
    },
  },
  variants: {
    variant: {
      inline: {
        textDecoration: "underline",
        fontWeight: "inherit",
        _hover: {
          textDecoration: "underline",
        },
      },
      standalone: {
        textDecoration: "none",
        fontWeight: 700,
        _hover: {
          textDecoration: "none",
        },
      },
      footer: {
        textDecoration: "none",
        fontWeight: 400,
        _hover: {
          textDecoration: "underline",
        },
      },
    },
  },
  defaultVariants: {
    variant: "inline",
  },
})

export type LinkVariantProps = RecipeVariant<typeof linkStyles>
